const routeChangeDurationMs = 200;
const rootFocusOn = "c2lrv64daj";
const panelCls = "c2lpboa5qa";
const closeButtonCls = "c2lc123mn8";
const routeCls = "c2lry84y75";
const toastsContainerCls = "c2ltift56";

export { closeButtonCls, panelCls, rootFocusOn, routeChangeDurationMs, routeCls, toastsContainerCls };
import "./panel.style.linaria.module.css";
//# sourceMappingURL=panel.style.js.map
